import { lazy } from "react"

export const FuelPage = lazy(() => import("./FuelPage"))
